import { render } from "./ApartamentSelect.vue?vue&type=template&id=b1dcaa98"
import script from "./ApartamentSelect.vue?vue&type=script&lang=js"
export * from "./ApartamentSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__